import { useMemo } from "react";
import styled from "styled-components";
import {
  DocumentPlusIcon,
  LockClosedIcon,
  SquaresPlusIcon,
} from "@heroicons/react/24/outline";
import {
  Header as HeaderPartial,
  Pills,
} from "@sablier/v2-components/molecules";
import { routes } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";

const Row = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    gap: ${(props) => props.theme.sizes.edge};
  }
`;

const Header = styled(HeaderPartial)`
  border-bottom: 2px solid ${(props) => props.theme.colors.border};

  ${(props) => props.theme.medias.maxXL} {
    ${Row} {
      gap: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
    }
  }

  ${(props) => props.theme.medias.maxMD} {
    display: block !important;

    ${Row} {
      width: 100%;
      margin-top: ${(props) => props.theme.sizes.edge};
      & > *:last-child {
        display: none;
      }
    }
  }

  ${(props) => props.theme.medias.maxXS} {
    padding-bottom: calc(${(props) => props.theme.sizes.edge} * 1);

    ${Row} {
      & > * {
        width: 100%;
        & > * {
          flex: 1;
          & > * {
            width: 100%;
          }
        }
      }
    }
  }
`;

interface Props {
  isGroup: boolean;
}

function Top({ isGroup = false }: Props) {
  const { t } = useT();

  const path = useMemo(
    () => [
      {
        title: routes.client.pages.dashboard.title,
        toPage: routes.client.pages.dashboard.builder(),
      },
      {
        title: isGroup
          ? routes.client.pages.galleryGroup.title
          : routes.client.pages.gallery.title,
      },
    ],
    [isGroup],
  );

  return (
    <Header back={path[0].toPage} path={path} title={t("structs.selectShape")}>
      <Row>
        <Pills
          activeId={isGroup ? "group" : "single"}
          list={[
            {
              id: "single",
              left: DocumentPlusIcon,
              purpose: "internal",
              title: t("words.single"),
              to: routes.client.pages.gallery.builder(),
              isReplacing: true,
            },
            {
              id: "group",
              left: SquaresPlusIcon,
              purpose: "internal",
              title: t("words.group"),
              to: routes.client.pages.galleryGroup.builder(),
              isReplacing: true,
            },
          ]}
        />
        <Pills
          list={[
            {
              id: "airstreams",
              title: t("structs.airstreams"),
              left: LockClosedIcon,
              isPreview: true,
            },
          ]}
        />
      </Row>
    </Header>
  );
}

export default Top;
